// ButtonGroupComponent.js
import React from "react";
import { Button, ButtonGroup } from "reactstrap";
import classNames from "classnames";

function ButtonGroupComponent({ activeButton, onButtonClick, buttons, size = "sm" }) {
  return (
    <ButtonGroup className="btn-group-toggle float-right cms-tab-bar" data-toggle="buttons">
      {buttons.map((button) => (
        <Button
          key={button}
          tag="label"
          color="info"
          size={size}
          id={button}
          className={classNames("btn-simple", {
            active: activeButton === button,
          })}
          onClick={() => onButtonClick(button)}
        >
          {button.charAt(0).toUpperCase() + button.slice(1)}
        </Button>
      ))}
    </ButtonGroup>
  );
}

export default ButtonGroupComponent;
